<template>
  <modal v-if="visible">
    <template slot="modal-header">
      <h2 class="mt-3">
        Audience Upload Instructions
      </h2>
    </template>
    <template slot="modal-body">
      <div class="px-3">
        <p>
          Permissions for audience selection and campaign application can be set
          via Type:
        </p>
        <div class="mb-4">
          <vue-good-table :columns="columns" :rows="rows"> </vue-good-table>
        </div>
        <p>
          Prior to upload please ensure your Customer Audience Data meets the
          below criteria:
        </p>
        <ul>
          <li>
            Includes a minimum of 200 contacts [the recommended minimum is 500]
          </li>
          <li>Is supplied in a CSV file in the required format</li>
          <li>Is supplied as raw data that has not been hashed or encrypted</li>
          <li>Is uniquely named</li>
        </ul>
      </div>
      <div class="px-3 pt-1">
        <div class="c__checkbox mb-2">
          <input
            type="checkbox"
            v-bind:checked="hideNextTime"
            v-on:click.stop="toggleHide()"
          />
          <label>Hide next time</label>
        </div>
        <button class="btn btn-primary" @click="handleConfirm">Okay</button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../../../helpers/Modal.vue';
import {VueGoodTable} from 'vue-good-table';
export default {
  props: ['visible'],
  data() {
    return {
      hideNextTime: false,
    };
  },
  components: {
    Modal,
    VueGoodTable,
  },
  methods: {
    handleConfirm() {
      this.closeModal();
    },
    closeModal() {
      this.$emit('close-modal');
    },
    toggleHide() {
      this.hideNextTime = !this.hideNextTime;
      localStorage.setItem('hide-audience-instructions', this.hideNextTime);
    },
  },
  computed: {
    columns() {
      return [
        {
          label: 'Type',
          field: 'type',
        },
        {
          label: 'Access',
          field: 'access',
        },
      ];
    },
    rows() {
      return [
        {
          id: 1,
          type: 'Global',
          access: 'All users in all of your offices',
        },
        {
          id: 2,
          type: 'Office',
          access: 'Only users in the selected offices',
        },
        {
          id: 3,
          type: 'Agent',
          access: 'Only the selected agents',
        },
      ];
    },
  },
  mounted() {
    const hide = localStorage.getItem('hide-audience-instructions');
    this.showModal = hide === 'true' ? false : true;
    this.hideNextTime = hide === 'true' ? true : false;
  },
};
</script>
